import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import reducer from "./reducer";

// Создаем middleware для логирования
const logger = store => next => action => {
    console.group(`Action: ${action.type}`);
    console.log('Предыдущее состояние:', store.getState());
    const result = next(action);
    console.log('Новое состояние:', store.getState());
    console.groupEnd();
    return result;
};

// Используем логгер только в режиме разработки
const middlewares = [thunk];
if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

const store = createStore(reducer, applyMiddleware(...middlewares));

export default store;